// extracted by mini-css-extract-plugin
export var bubble = "_3c-0";
export var container = "_3c-f";
export var contrastBorder = "_3c-g";
export var greyOut = "_3c-2";
export var initialsColor0 = "_3c-3";
export var initialsColor1 = "_3c-4";
export var initialsColor10 = "_3c-d";
export var initialsColor11 = "_3c-e";
export var initialsColor2 = "_3c-5";
export var initialsColor3 = "_3c-6";
export var initialsColor4 = "_3c-7";
export var initialsColor5 = "_3c-8";
export var initialsColor6 = "_3c-9";
export var initialsColor7 = "_3c-a";
export var initialsColor8 = "_3c-b";
export var initialsColor9 = "_3c-c";
export var initialsWrapper = "_3c-1";
export var large = "_3c-l";
export var medium = "_3c-k";
export var mediumSmall = "_3c-j";
export var mediumSmallMedium = "_3c-o";
export var micro = "_3c-h";
export var small = "_3c-i";
export var tiny = "_3c-n";
export var xTiny = "_3c-m";